import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

export const logOutUser = async () => {
  const response = await axios({
    method: "get",
    url: baseurl + `/logout`,
    headers: {
      token: token,
    },
  });
};
